import React from "react";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { useNavigate } from "react-router-dom";

const KPICard = ({ title, data, dataIcon, trend, tooltip, loading, link }) => {
  const navigate = useNavigate();
  const trendIcon = {
    same: "pi-arrow-right",
    improved: "pi-arrow-up-right",
    worsened: "pi-arrow-down-right",
    "worsened-flat": "pi-arrow-right",
    "worsened-top": "pi-arrow-up-right",
    "worsened-down": "pi-arrow-down-right",
    "improve-down": "pi-arrow-down-right",
  };
  return (
    <div className="w-full kpi__card--container">
      {tooltip && <Tooltip target=".info-icon-tooltip" />}
      <p className="title m-0">
        <span
          className={`cursor-pointer ${link ? "link_style" : ""}`}
          onClick={() => {
            if (link) navigate(link);
          }}
        >
          {title}
        </span>
        {tooltip && (
          <span>
            <i
              className="pi pi-info-circle info-icon ml-1 info-icon-tooltip"
              data-pr-tooltip={tooltip}
            />
          </span>
        )}
      </p>
      <div className="flex flex-column gap-2">
        {!loading ? (
          <p className="kpi__calculation-data font-semibold m-0">
            {dataIcon && <i className={`${dataIcon} info-icon mr-1`} />}
            {data}
          </p>
        ) : (
          <Skeleton width="50%" />
        )}

        {!loading ? (
          <p className={`flex align-items-center trend m-0 ${trend?.type}`}>
            <i className={`pi ${trendIcon[trend?.type]} ${trend?.type}`} />
            <span className="ml-1 ">{trend?.percentage}</span>
            <span className="ml-1 ">{trend?.description}</span>
          </p>
        ) : (
          <Skeleton width="100%" />
        )}
      </div>
    </div>
  );
};

export default KPICard;
